import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import DynamicField from "./customizeform/DynamicFirelds";

const FindMyModalSize = ({
    show,
    handleClose,
    onSelectSize,
    fields,
    formData,
    onChange
}) => {
    const [form, setForm] = useState({
        chest: "",
        waist: "",
        hip: "",
        height: "",
        weight: "",
    });

    const [recommendedSize, setRecommendedSize] = useState("");



    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const recommendSize = () => {
        const chest = Number(formData.chest_inches);

        let size = "";

        if (chest <= 36) size = "S";
        else if (chest <= 38) size = "M";
        else if (chest <= 40) size = "L";
        else if (chest <= 42) size = "XL";
        else size = "XXL";

        setRecommendedSize(size);
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Customize Size</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {fields?.map((field) => (
                    <div key={field.key} className="mb-3">
                        <label className="form-label">
                            {field.label}
                        </label>
                        <DynamicField
                            field={field}
                            value={formData[field.key]}
                            onChange={onChange}
                        />
                        {/* {field.sublabel && (
                            <small>{field.sublabel}</small>
                        )} */}
                    </div>
                ))}
                <Button
                    type="submit"
                    variant="dark"
                    className="w-100"
                    onClick={() => onSelectSize(recommendedSize)}
                >
                    Submit
                </Button>

                {/* {recommendedSize && (
          <div className="mt-4 text-center">
            <h5>Recommended Size</h5>

            <h2 className="text-success">
              {recommendedSize}
            </h2>

            <Button
              variant="success"
              onClick={() => onSelectSize(recommendedSize)}
            >
              Use This Size
            </Button>
          </div>
        )} */}

            </Modal.Body>
        </Modal>
    );
};

export default FindMyModalSize;